/**
 * Contains a list of environment variables
 * API Endpoints
 * API Keys
 * Public frontends urls
 */

const DOMAIN_NAME = 'staging.micetribe.com'
const V2BaseUrl = `https://api.${DOMAIN_NAME}/v3/`
export const environment = {
  production: false,
  integrationsApi: `https://api.${DOMAIN_NAME}/integrations/v1/`,
  genericApi: 'https://api.staging.micetribe.com/v3/',
  micetribeEvents: 'https://events.staging.micetribe.com/',
  planningApi: 'https://api.staging.micetribe.com/v3/plan/contactless/',
  planningDashboard: 'https://api.staging.micetribe.com/v3/dashboards/',
  registrationsApi: 'https://api.staging.micetribe.com/v3/registrations/',
  searchApi: 'https://api.staging.micetribe.com/v3/search',
  elasticSearch: 'https://api.staging.micetribe.com/v3/elasticsearch',
  handshakesApi: 'https://api.staging.micetribe.com/v3/handshake/',
  exportsApi: 'https://exports.staging.micetribe.com/',
  publicFormsUrl: 'https://app.staging.micetribe.com/public/',
  landingPageUrl: 'https://app.staging.micetribe.com/register/',
  baseFormsUrl: 'https://app.staging.micetribe.com',
  baseUrl: 'https://plan.staging.micetribe.com/',
  stripeKey: 'pk_test_47Z7iMDWR236BIUktKpxkWXG',
  publicGoogleMapsAPIKey: 'AIzaSyBE9vDiiFxTVsZJem1gnxPpCZQrpr9ApSM',
  googleMapsAPIKey: 'AIzaSyCchlV70JS27eCJaaSqZKLaUf3gDJf6Ejc',
  crewApi: 'https://api.staging.micetribe.com/v3/crew/',
  baseContactlessApi: 'https://api.staging.micetribe.com/',
  dashboardsBaseUrl: 'https://dashboards.staging.micetribe.com/',
  publicPersonaPageUrl: 'https://events.staging.micetribe.com/',
  benchmarkApi: 'https://clientapi.benchmarkemail.com/',
  benchmarkExportApi: 'https://api.staging.micetribe.com/v3/benchmark/',
  rtsUrl: 'https://rts.staging.micetribe.com/',
  rtsWS: 'wss://rts.staging.micetribe.com/ws/',
  crewSystem: 'https://crew.staging.micetribe.com',
  industrySector: 'https://api.staging.micetribe.com/v3/plan/contactless/industrySector',
  appVersion: 'staging.build-2610',
  gaMeasurementId: '',
  mediaLibrary: 'https://api.staging.micetribe.com/v3/library/',
  sentry: {
    dsn: 'https://cb0fc58bdb02ae1746582c2d353095cf@o4510713697599488.ingest.de.sentry.io/4510730198712400',
    environment: 'staging',
    sampleRate: 0.1,
    tracesSampleRate: 0.1
  },
  posthog: {
    apiKey: 'phc_1eV0W7NPrSrB6vQbJtBI6AIGdXY3KVXo96CJjp0AmvK',
    host: 'https://eu.i.posthog.com',
    apiProjectUrl: 'https://eu.posthog.com/project/52788/'
  },
  v2: {
    phoneNumber: '971585236423',
    baseUrl: V2BaseUrl
  },
  authUiUrl: 'https://auth.staging.micetribe.com',
  oauth: {
    clientId: '3',
    authorizeUrl: 'https://api.staging.micetribe.com/v3/oauth/authorize',
    tokenUrl: 'https://api.staging.micetribe.com/v3/oauth/token',
    redirectUri: 'https://plan.staging.micetribe.com/auth/login'
  },
  mjml: {
    apiUrl: 'https://api.mjml.io/v1',
    applicationId: '843e92e6-e399-4c6a-8249-ef963e746f8d',
    publicKey: 'f8d33a18-1f82-4274-845f-db03d88dea3f'
  },
  googleClientID: '671059974212-j3kea3jrg8408uht1qnd1rqvblk921t4.apps.googleusercontent.com',
  linkedinClientID: '772jwev8ar9ai0',
  s3_files_root: `https://micetribe-staging-storage.s3.eu-west-3.amazonaws.com/`,
  betaFeaturesUrl: 'https://micetribe-ff.s3.eu-west-3.amazonaws.com/beta.staging.json' // URL to JSON file containing beta features configuration
}
